import EkbIcon from '../../ekbIcon';
import React from 'react';
import Member from './images/member.svg';
export function renderIcon(item) {
    if (!item) {
        return React.createElement(React.Fragment, null);
    }
    if (!item.type) {
        return getStaffAvatar(item);
    }
    switch (item.type) {
        case 'staff':
            return getStaffAvatar(item);
        case 'role':
            return React.createElement(EkbIcon, { name: "#EDico-role-fill", className: "staff-avatar role_bg" });
        case 'department':
            return React.createElement(EkbIcon, { name: "#EDico-folder-fill", className: "staff-avatar department_bg" });
        default:
            return React.createElement(React.Fragment, null);
    }
}
var getStaffAvatar = function (item) {
    if (item === null || item === void 0 ? void 0 : item.avatar) {
        return React.createElement("img", { className: "staff-avatar", src: "" + item.avatar, alt: "" });
    }
    return (React.createElement("div", { className: "staff-avatar" },
        React.createElement("img", { style: { width: 8, height: 8 }, src: "" + Member, alt: "" })));
};
export function personName(name, CHINESENUM, ENGLISHNUM) {
    var isChina = /.*[\u4e00-\u9fa5]+.*$/.test(name);
    var index = isChina ? CHINESENUM : ENGLISHNUM;
    if (name && name.length > index) {
        return name.substring(0, index) + '...';
    }
    return name;
}
